import api from "../storeApi";
import { createAsyncActionWithMeta } from "../../../../../libraries/packages/redux-utils/src/request/action";
export const mapPlacesGetAction = createAsyncActionWithMeta(
  "mapPlaces_mapPlacesGetAction_REQUEST",
  "mapPlaces_mapPlacesGetAction_SUCCESS",
  "mapPlaces_mapPlacesGetAction_FAILURE"
)<Parameters<typeof api.pinPlaces.methods.get>, any, Error>();
